import axios from 'axios';
import { axiosConfig } from '@/config/axiosConfig.js'

export async function get_live_traffic_data(api_path, old_update_time) {
    const colorMap = {
        "1": "#61b12f", //順暢
        "2": "#eeea39", //車多
        "3": "#ed8f27", //車多
        "4": "#e93d27", //壅塞
        "5": "#8766e9",  //嚴重壅塞
        "-1": "#D3D3D3",
    };
    const res = await get_live_traffic_ajax(api_path)
    const traffic_data = res.data.LiveTraffics
    const update_time = res.data.UpdateTime

    if (update_time === old_update_time) {
        console.log('no need update traffic data')
        return { update_time }
    }

    const road_info_mapping = traffic_data.reduce((accum, datum) => {
        const {
            SectionID, 
            CongestionLevel, 
            TravelSpeed: speed,
            TravelTime: time,
        } = datum
        return {...accum, ...{
            [SectionID]: {
                color: colorMap[CongestionLevel],
                speed,
                time
            }, 
        }}
    }, {})
    return {
        update_time, 
        road_info_mapping
    }
    
}

function get_live_traffic_ajax(link) {
    return axios.get(link, axiosConfig)
}